
import React, { useRef, useState } from 'react'
import { Offset, Popup } from '@progress/kendo-react-popup';
import { Menu, MenuItem, MenuSelectEvent } from '@progress/kendo-react-layout';
import { MenuOption } from '../types/MenuOption';
import { Button } from "@progress/kendo-react-buttons";
import { MenuProps } from './ChatOptions';
import { ChatApi } from '../redux/api/ChatApi';
import { useReduxDispatch, useReduxSelector } from '../redux/hooks';
import { SetVisibility } from '../redux/reducers/ChatSlice';


export default function ChatVisibilityMenu() {
    const dispatch = useReduxDispatch();
    const staffOnline = useReduxSelector(r => r.chat.usersOnline);
    const { data: userProfile, error } = ChatApi.useGetProfileQuery();
    const { data } = ChatApi.useGetMyVisibilityQuery();
    const [updateVisibility] = ChatApi.useUpdateUserVisibilityMutation();
    const [menu, setMenu] = useState<MenuProps>({} as MenuProps)
    const options: MenuOption[] = [
        {
            id: userProfile?.Uid,
            title: 'Your visibility',
            image: data?.Visibility == 0 ? './images/chat_off.jpg' : data?.Visibility == 2 ? './images/chat_all.jpg' : './images/chat_internal.jpg',
            onclick: () => { },
            visibility: data?.Visibility,
        } as MenuOption,

    ]

    const menuItemSelected = (e: MenuSelectEvent) => {
        //Fire the click event for this option
        console.log('menuItemSelected', e.item.data);

        //Update the visibility via the API
        updateVisibility({ Visibility: e.item.data, Contact_Id: userProfile.Id, ID: 0 }).unwrap()
            .then(() => {
                //reconnect to signalR
                console.log('reconnect to signalR')
                dispatch(SetVisibility(e.item.data));
            });

        //Hide the menu
        setMenu(null);
    }


    return (
        <>
            <Button className='' icon='more-horizontal' fillMode='flat' onClick={(e) => setMenu((v) => {
                //console.log(e.currentTarget.offsetLeft, e.currentTarget.offsetTop)
                return { visible: !v?.visible, offset: { top: e.clientY + 20, left: e.clientX - 150 } } as MenuProps
            })}></Button>
            <Popup show={menu?.visible}
                offset={menu?.offset}
                anchorAlign={{ horizontal: 'right', vertical: 'bottom' }} className='chat-menu' collision={{ horizontal: 'fit', vertical: 'fit' }}  >
                <Menu className='chat-header-menu' vertical={true} style={{ display: "inline-block" }} onSelect={menuItemSelected} openOnClick={false} hoverCloseDelay={100}  >
                    {options.map(o => (
                        <MenuItem key={-1} render={() => {
                            return <div> <img src={o.image} className='tool-image' /><span>{o.title}</span></div>
                        }} icon={o.icon?.replace('k-i-', '')} text={o.title} data={o.id} >
                            <MenuItem key={0} data={2} render={() => {
                                return <div className='vis-menu-option'><span>Internal / External</span>{o.visibility === 2 && <span className='k-icon k-i-check-circle'></span>}</div>
                            }} ></MenuItem>
                            <MenuItem key={1} data={1} render={() => {
                                return <div className='vis-menu-option'><span>Internal</span>{o.visibility === 1 && <span className='k-icon k-i-check-circle'></span>}</div>
                            }} ></MenuItem>
                            <MenuItem key={2} data={0} render={() => {
                                return <div className='vis-menu-option'><span>Offline</span>{o.visibility === 0 && <span className='k-icon k-i-check-circle'></span>}</div>
                            }} >
                            </MenuItem>
                        </MenuItem>
                    ))}
                </Menu>
            </Popup>
        </>
    )
}



